export const formatCurrency = (
  count?: string | number,
  currency = 'грн',
): string => {
  const value = Number(count) || 0;
  const minimumFractionDigits = 2;
  const maximumFractionDigits = 2;

  return (
    new Intl.NumberFormat('uk', {
      style: 'decimal',
      minimumFractionDigits,
      maximumFractionDigits,
    }).format(value) +
    String.fromCharCode(0x00a0) +
    currency
  );
};
